<div class="d-flex" (click)="selectedItemChange.emit(checkItem); itemSelected = !itemSelected" [ngClass]="{ 'on-screen-check-item-select': itemSelected }">
	<div class="me-1">{{ checkItem.quantity }}</div>
	<div class="">{{ checkItem.name }}</div>
	<div class="ms-auto">{{ checkItem.price | currency }}</div>
	<div *ngIf="checkItem.positionId" class="">{{ checkItem.positionId }}</div>
</div>
